/** 
 * Limit a number to a range
*/
export const limitToRange = (value: number, min: number, max: number) => {
  return Math.max(min, Math.min(max, value));
}